/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type ChartIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let ChartIcon: NessieFunctionComponent<ChartIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.206 2a7.145 7.145 0 015.77 4.328l-6.652 2.846L15.206 2zM12.44 4.525l-1.042 8.616s7.815-3.446 7.855-3.366a8.846 8.846 0 01.521 4.128c-.56 4.609-4.769 7.895-9.378 7.334-4.608-.561-7.895-4.77-7.334-9.378.561-4.609 4.77-7.895 9.378-7.334z"
          />
          <mask maskUnits="userSpaceOnUse" x={3} y={2} width={18} height={20}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.206 2a7.145 7.145 0 015.77 4.328l-6.652 2.846L15.206 2zM12.44 4.525l-1.042 8.616s7.815-3.446 7.855-3.366a8.846 8.846 0 01.521 4.128c-.56 4.609-4.769 7.895-9.378 7.334-4.608-.561-7.895-4.77-7.334-9.378.561-4.609 4.77-7.895 9.378-7.334z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
ChartIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  ChartIcon = nessiePropCheckerWrapper(ChartIcon);
}

export default ChartIcon;
